import { render, staticRenderFns } from "./WorkerDetail.vue?vue&type=template&id=1c3d4c84"
import script from "./WorkerDetail.vue?vue&type=script&lang=ts"
export * from "./WorkerDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports